import React from 'react'
import { useTaskStatus } from '../../../Hooks/Features/TaskLayout/TaskStatus/useTaskStatus'
import CommonGrid from '../../../components/CommonCompo/CommonGrid/CommonGrid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from "underscore";
import { Dialog } from 'primereact/dialog';
import { renderField } from '../../../utils/Helper';
import CommanDialog from '../../../components/CommonCompo/CommanDialog/CommanDialog';

const TaskStatus = () => {

    const { columns, rowData, loader, getIssueStatus, formFields, formValues, setFormValues, saveStatus, scrollRef } = useTaskStatus();

    return (
        <div>
            <div className='sk-header-row d-flex gap-1 justify-content-between'>
                <input className='sk-input-dd w80 mb-0' placeholder='Search Status...' value={formValues?.search} onChange={(e) => setFormValues((prev) => ({ ...prev, search: e?.target?.value }))} />
                <div className='d-flex gap-1 align-items-center'>
                    <button className='sk-btn sk-btn-primary' title='Refresh' onClick={() => getIssueStatus()}><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
                    <button className='sk-btn sk-btn-primary bg-black text-white' title='Create new hierarchy level' onClick={() => setFormValues((prev) => ({ ...prev, visible: true, order: rowData?.length + 1 }))}><FontAwesomeIcon icon="fa-solid fa-plus" /> Status</button>
                </div>
            </div>
            <div ref={scrollRef} style={{ height: "calc(100vh - 110px)", overflow: "auto" }}>
                <CommonGrid columns={columns} data={_.isEmpty(rowData) ? [] : [{ id: "all", title: "", children: rowData }]} headerHeight={40} rowHeight={40} loader={loader?.grid} strippedTable={true} />
            </div>

            <Dialog visible={formValues?.visible} onHide={() => setFormValues({ visible: false })} header={`${_.isEmpty(formValues?.editData) ? "Add" : "Edit"} Status`} draggable={false} className='modal-xsmall'>
                <div className='row'>
                    {formFields?.map((item, index) => (
                        renderField(item, index, (e, is_edit) => { setFormValues((prev) => ({ ...prev, [item?.name]: item?.name === "order" ? (_.isNaN(parseInt(e?.target?.value)) ? "" : parseInt(e?.target?.value)) : e?.target?.value })) }, formValues, {}, {}, () => { }, () => { })
                    ))}
                    <div className='d-flex gap-1 justify-content-end align-items-center mt-2'>
                        <button className='sk-btn sk-btn-primary' onClick={() => setFormValues({ visible: false })}>Cancel</button>
                        {loader?.btn ? <button className="sk-btn sk-btn-primary bg-black text-white" style={{ width: "45px" }}>
                            <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                            <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => saveStatus()}>Add</button>
                        }
                    </div>
                </div>
            </Dialog>

            <CommanDialog visible={formValues?.isDelete} handleClose={() => setFormValues({ visible: false })} handleFun={() => saveStatus()} message="Are you sure you want to delete this status?" />
        </div>
    )
}

export default TaskStatus